export const BuildInfo = {timestamp:1782588274000}
